import commonErrors from './common/errors.js'

/**
 * @exports COMPANY_GROUP_NAME
 */
export const COMPANY_GROUP_NAME = 'Adevinta'

/**
 * @exports DESIGN_SYSTEM_THEME
 */
export const DESIGN_SYSTEM_THEME = 'motor'

/**
 * @exports URL_PROTOCOL
 */
export const URL_PROTOCOL = 'https://'

/**
 * @exports urlStatics
 */
export const urlStatics = 'https://s.ccdn.es/'

/**
 * @exports URL_STATICS_IMAGES
 */
export const URL_STATICS_IMAGES = `${urlStatics}images/`

/**
 * @exports TRUST_API_PATH
 */
export const TRUST_API_PATH = '/trust'

/**
 * @exports USER_DEFAULT_AVATAR_URL
 */
export const USER_DEFAULT_AVATAR_URL = `${URL_STATICS_IMAGES}user-default-avatar.svg`

/**
 * @exports i18nLiteralsEndpoint
 */
export const i18nLiteralsEndpoint = 'json/languages.json'

/**
 * @exports URL_CULTURES_MAP
 */
export const URL_CULTURES_MAP = {
  'es-ES': 'es'
}

/**
 * @exports DEFAULT_CULTURE
 */
export const DEFAULT_CULTURE = 'es-ES'

export const DEFAULT_CURRENCY = 'EUR'

export const TIMEZONE_BY_CULTURE = {
  [DEFAULT_CULTURE]: 'Europe/Madrid'
}

/**
 * @exports DEFAULT_PAGE_NUMBER
 */
export const DEFAULT_PAGE_NUMBER = 1

/**
 * @exports EMPTY_RESULTS_NUMBER
 */
export const EMPTY_RESULTS_NUMBER = 0

/**
 * @exports POSTAL_CODE_PATTERN
 */
export const POSTAL_CODE_PATTERN = /^(\d{0,5}|\s)$/

/**
 * @exports sellerTypes
 */
export const sellerTypes = [
  {
    id: 2,
    label: 'COMMON_PRIVATE'
  },
  {
    id: 1,
    label: 'COMMON_PROFESSIONAL'
  }
]

const aCoruña = {
  id: 15,
  isPeninsula: true,
  label: 'A Coruña',
  slug: 'a_coruna'
}
const albacete = {
  id: 2,
  isPeninsula: true,
  label: 'Albacete',
  slug: 'albacete'
}
const alicante = {
  id: 3,
  isPeninsula: true,
  label: 'Alicante',
  slug: 'alicante'
}
const almeria = {
  id: 4,
  isPeninsula: true,
  label: 'Almería',
  slug: 'almeria'
}
const araba = {
  id: 1,
  isPeninsula: true,
  label: 'Araba',
  slug: 'alava'
}
const asturias = {
  id: 33,
  isPeninsula: true,
  label: 'Asturias',
  slug: 'asturias'
}
const avila = {
  id: 5,
  isPeninsula: true,
  label: 'Ávila',
  slug: 'avila'
}
const badajoz = {
  id: 6,
  isPeninsula: true,
  label: 'Badajoz',
  slug: 'badajoz'
}
const baleares = {
  id: 7,
  isPeninsula: false,
  label: 'Baleares',
  slug: 'baleares'
}
const barcelona = {
  id: 8,
  isPeninsula: true,
  label: 'Barcelona',
  slug: 'barcelona'
}
const bizkaia = {
  id: 48,
  isPeninsula: true,
  label: 'Bizkaia',
  slug: 'vizcaya'
}
const burgos = {
  id: 9,
  isPeninsula: true,
  label: 'Burgos',
  slug: 'burgos'
}
const caceres = {
  id: 10,
  isPeninsula: true,
  label: 'Cáceres',
  slug: 'caceres'
}
const cadiz = {
  id: 11,
  isPeninsula: true,
  label: 'Cádiz',
  slug: 'cadiz'
}
const cantabria = {
  id: 39,
  isPeninsula: true,
  label: 'Cantabria',
  slug: 'cantabria'
}
const castellon = {
  id: 12,
  isPeninsula: true,
  label: 'Castellón',
  slug: 'castellon'
}
const ceuta = {
  id: 51,
  isPeninsula: false,
  label: 'Ceuta',
  slug: 'ceuta'
}
const ciudadReal = {
  id: 13,
  isPeninsula: true,
  label: 'Ciudad Real',
  slug: 'ciudad_real'
}
const cordoba = {
  id: 14,
  isPeninsula: true,
  label: 'Córdoba',
  slug: 'cordoba'
}
const cuenca = {
  id: 16,
  isPeninsula: true,
  label: 'Cuenca',
  slug: 'cuenca'
}
const gipuzkoa = {
  id: 20,
  isPeninsula: true,
  label: 'Gipuzkoa',
  slug: 'guipuzcoa'
}
const girona = {
  id: 17,
  isPeninsula: true,
  label: 'Girona',
  slug: 'girona'
}
const granada = {
  id: 18,
  isPeninsula: true,
  label: 'Granada',
  slug: 'granada'
}
const guadalajara = {
  id: 19,
  isPeninsula: true,
  label: 'Guadalajara',
  slug: 'guadalajara'
}
const huelva = {
  id: 21,
  isPeninsula: true,
  label: 'Huelva',
  slug: 'huelva'
}
const huesca = {
  id: 22,
  isPeninsula: true,
  label: 'Huesca',
  slug: 'huesca'
}
const jaen = {
  id: 23,
  isPeninsula: true,
  label: 'Jaén',
  slug: 'jaen'
}
const laRioja = {
  id: 26,
  isPeninsula: true,
  label: 'La Rioja',
  slug: 'la_rioja'
}
const lasPalmas = {
  id: 35,
  isPeninsula: false,
  label: 'Las Palmas',
  slug: 'las_palmas'
}
const leon = {
  id: 24,
  isPeninsula: true,
  label: 'León',
  slug: 'leon'
}
const lleida = {
  id: 25,
  isPeninsula: true,
  label: 'Lleida',
  slug: 'lleida'
}
const lugo = {
  id: 27,
  isPeninsula: true,
  label: 'Lugo',
  slug: 'lugo'
}
const madrid = {
  id: 28,
  isPeninsula: true,
  label: 'Madrid',
  slug: 'madrid'
}
const malaga = {
  id: 29,
  isPeninsula: true,
  label: 'Málaga',
  slug: 'malaga'
}
const melilla = {
  id: 52,
  isPeninsula: false,
  label: 'Melilla',
  slug: 'melilla'
}
const murcia = {
  id: 30,
  isPeninsula: true,
  label: 'Murcia',
  slug: 'murcia'
}
const navarra = {
  id: 31,
  isPeninsula: true,
  label: 'Navarra',
  slug: 'navarra'
}
const ourense = {
  id: 32,
  isPeninsula: true,
  label: 'Ourense',
  slug: 'ourense'
}
const palencia = {
  id: 34,
  isPeninsula: true,
  label: 'Palencia',
  slug: 'palencia'
}
const pontevedra = {
  id: 36,
  isPeninsula: true,
  label: 'Pontevedra',
  slug: 'pontevedra'
}
const salamanca = {
  id: 37,
  isPeninsula: true,
  label: 'Salamanca',
  slug: 'salamanca'
}
const segovia = {
  id: 40,
  isPeninsula: true,
  label: 'Segovia',
  slug: 'segovia'
}
const sevilla = {
  id: 41,
  isPeninsula: true,
  label: 'Sevilla',
  slug: 'sevilla'
}
const soria = {
  id: 42,
  isPeninsula: true,
  label: 'Soria',
  slug: 'soria'
}
const staCruzTenerife = {
  id: 38,
  isPeninsula: false,
  label: 'Sta. C. Tenerife',
  slug: 'sta_c_tenerife'
}
const tarragona = {
  id: 43,
  isPeninsula: true,
  label: 'Tarragona',
  slug: 'tarragona'
}
const teruel = {
  id: 44,
  isPeninsula: true,
  label: 'Teruel',
  slug: 'teruel'
}
const toledo = {
  id: 45,
  isPeninsula: true,
  label: 'Toledo',
  slug: 'toledo'
}
const valencia = {
  id: 46,
  isPeninsula: true,
  label: 'Valencia',
  slug: 'valencia'
}
const valladolid = {
  id: 47,
  isPeninsula: true,
  label: 'Valladolid',
  slug: 'valladolid'
}
const zamora = {
  id: 49,
  isPeninsula: true,
  label: 'Zamora',
  slug: 'zamora'
}
const zaragoza = {
  id: 50,
  isPeninsula: true,
  label: 'Zaragoza',
  slug: 'zaragoza'
}

/**
 * @exports filteredProvincesResults
 */
export const filteredProvincesResults = {
  UNKNOWN: 'unknown',
  ALL: 'all'
}

export const provincesById = {
  [aCoruña.id]: aCoruña,
  [albacete.id]: albacete,
  [alicante.id]: alicante,
  [almeria.id]: almeria,
  [araba.id]: araba,
  [asturias.id]: asturias,
  [avila.id]: avila,
  [badajoz.id]: badajoz,
  [baleares.id]: baleares,
  [barcelona.id]: barcelona,
  [bizkaia.id]: bizkaia,
  [burgos.id]: burgos,
  [caceres.id]: caceres,
  [cadiz.id]: cadiz,
  [cantabria.id]: cantabria,
  [castellon.id]: castellon,
  [ceuta.id]: ceuta,
  [ciudadReal.id]: ciudadReal,
  [cordoba.id]: cordoba,
  [cuenca.id]: cuenca,
  [gipuzkoa.id]: gipuzkoa,
  [girona.id]: girona,
  [granada.id]: granada,
  [guadalajara.id]: guadalajara,
  [huelva.id]: huelva,
  [huesca.id]: huesca,
  [jaen.id]: jaen,
  [laRioja.id]: laRioja,
  [lasPalmas.id]: lasPalmas,
  [leon.id]: leon,
  [lleida.id]: lleida,
  [lugo.id]: lugo,
  [madrid.id]: madrid,
  [malaga.id]: malaga,
  [melilla.id]: melilla,
  [murcia.id]: murcia,
  [navarra.id]: navarra,
  [ourense.id]: ourense,
  [palencia.id]: palencia,
  [pontevedra.id]: pontevedra,
  [salamanca.id]: salamanca,
  [segovia.id]: segovia,
  [sevilla.id]: sevilla,
  [soria.id]: soria,
  [staCruzTenerife.id]: staCruzTenerife,
  [tarragona.id]: tarragona,
  [teruel.id]: teruel,
  [toledo.id]: toledo,
  [valencia.id]: valencia,
  [valladolid.id]: valladolid,
  [zamora.id]: zamora,
  [zaragoza.id]: zaragoza
}

/**
 * @exports provinces
 */
export const provinces = [
  aCoruña,
  albacete,
  alicante,
  almeria,
  araba,
  asturias,
  avila,
  badajoz,
  baleares,
  barcelona,
  bizkaia,
  burgos,
  caceres,
  cadiz,
  cantabria,
  castellon,
  ceuta,
  ciudadReal,
  cordoba,
  cuenca,
  gipuzkoa,
  girona,
  granada,
  guadalajara,
  huelva,
  huesca,
  jaen,
  laRioja,
  lasPalmas,
  leon,
  lleida,
  lugo,
  madrid,
  malaga,
  melilla,
  murcia,
  navarra,
  ourense,
  palencia,
  pontevedra,
  salamanca,
  segovia,
  sevilla,
  soria,
  staCruzTenerife,
  tarragona,
  teruel,
  toledo,
  valencia,
  valladolid,
  zamora,
  zaragoza
]

export const provincesByCCAA = [
  {id: 'andalucia', label: 'Andalucía', items: [almeria, cadiz, cordoba, granada, huelva, jaen, malaga, sevilla]},
  {id: 'aragon', label: 'Aragón', items: [huesca, teruel, zaragoza]},
  {id: 'canarias', label: 'Canarias', items: [lasPalmas, staCruzTenerife]},
  {id: 'cantabria', label: 'Cantabria', items: [cantabria]},
  {id: 'castilla_la_mancha', label: 'Castilla-La Mancha', items: [albacete, ciudadReal, cuenca, guadalajara, toledo]},
  {
    id: 'castilla_y_leon',
    label: 'Castilla y León',
    items: [avila, burgos, leon, palencia, salamanca, segovia, soria, valladolid, zamora]
  },
  {id: 'catalunya', label: 'Catalunya', items: [barcelona, girona, lleida, tarragona]},
  {id: 'ciudades_autonomas', label: 'Ciudades autónomas', items: [ceuta, melilla]},
  {id: 'comunidad_de_madrid', label: 'Comunidad de Madrid', items: [madrid]},
  {id: 'comunidad_foral_de_navarra', label: 'Comunidad Foral de Navarra', items: [navarra]},
  {id: 'comunitat_valenciana', label: 'Comunitat Valenciana', items: [alicante, castellon, valencia]},
  {id: 'euskadi', label: 'Euskadi', items: [araba, gipuzkoa, bizkaia]},
  {id: 'extremadura', label: 'Extremadura', items: [badajoz, caceres]},
  {id: 'galicia', label: 'Galicia', items: [aCoruña, lugo, ourense, pontevedra]},
  {id: 'illes_balears', label: 'Illes Balears', items: [baleares]},
  {id: 'la_rioja', label: 'La Rioja', items: [laRioja]},
  {id: 'principado_de_asturias', label: 'Principado de Asturias', items: [asturias]},
  {id: 'region_de_murcia', label: 'Región de Murcia', items: [murcia]}
]

/**
 * @exports CANARIAS_PROVINCE_IDS
 */
export const CANARIAS_PROVINCE_IDS = [lasPalmas.id, staCruzTenerife.id]

export const FEATURED_CITIES = [
  {
    provinceId: 28,
    name: 'Madrid',
    imageSrc: 'common/cities/madrid.jpg'
  },
  {
    provinceId: 8,
    name: 'Barcelona',
    imageSrc: 'common/cities/barcelona.jpg'
  },
  {
    provinceId: 46,
    name: 'Valencia',
    imageSrc: 'common/cities/valencia.jpg'
  },
  {
    provinceId: 41,
    name: 'Sevilla',
    imageSrc: 'common/cities/sevilla.jpg'
  },
  {
    provinceId: 50,
    name: 'Zaragoza',
    imageSrc: 'common/cities/zaragoza.jpg'
  },
  {
    provinceId: 29,
    name: 'Málaga',
    imageSrc: 'common/cities/malaga.jpg'
  },
  {
    provinceId: 30,
    name: 'Murcia',
    imageSrc: 'common/cities/murcia.jpg'
  },
  {
    provinceId: 7,
    name: 'Palma de Mallorca',
    imageSrc: 'common/cities/mallorca.jpg'
  },
  {
    provinceId: 35,
    name: 'Las Palmas',
    imageSrc: 'common/cities/la-palma.jpg'
  },
  {
    provinceId: 48,
    name: 'Bilbao',
    imageSrc: 'common/cities/bilbao.jpg'
  }
]

export const SEARCH_SECTION_IDS = {
  allOffers: 0,
  secondHand: 1,
  newVehicles: 2,
  km0: 6,
  news: 8,
  configurator: 11,
  wdyl: 23,
  make: 25,
  model: 26
}

export const SEARCH_SECTION_ID_MAPPING = {
  [SEARCH_SECTION_IDS.allOffers]: 'all_offers',
  [SEARCH_SECTION_IDS.secondHand]: 'second_hand',
  [SEARCH_SECTION_IDS.km0]: 'km0',
  [SEARCH_SECTION_IDS.newVehicles]: 'new_vehicles',
  [SEARCH_SECTION_IDS.news]: 'news',
  [SEARCH_SECTION_IDS.wdyl]: 'wdyl',
  [SEARCH_SECTION_IDS.make]: 'technical_details_make',
  [SEARCH_SECTION_IDS.model]: 'technical_details_model',
  [SEARCH_SECTION_IDS.configurator]: 'vehicle_configurator'
}

const DEFAULT_TAGCLOUD_ENDPOINT = 'tagcloud-groups'

export const TAGCLOUD_ENDPOINTS = {
  default: {
    endpoint: DEFAULT_TAGCLOUD_ENDPOINT,
    params: {
      searchSectionId: SEARCH_SECTION_IDS.secondHand
    }
  },
  make: {
    endpoint: DEFAULT_TAGCLOUD_ENDPOINT,
    params: {
      name: 'make',
      searchSectionId: SEARCH_SECTION_IDS.news
    }
  },
  newVehicles: {
    endpoint: DEFAULT_TAGCLOUD_ENDPOINT,
    params: {
      searchSectionId: SEARCH_SECTION_IDS.newVehicles
    }
  },
  stock: {
    endpoint: DEFAULT_TAGCLOUD_ENDPOINT,
    params: {
      name: 'stock',
      searchSectionId: SEARCH_SECTION_IDS.model
    }
  },
  wdyl: {
    endpoint: DEFAULT_TAGCLOUD_ENDPOINT,
    params: {
      name: 'wdyl',
      searchSectionId: SEARCH_SECTION_IDS.wdyl
    }
  },
  news: {
    endpoint: DEFAULT_TAGCLOUD_ENDPOINT,
    params: {
      name: 'news',
      searchSectionId: SEARCH_SECTION_IDS.news
    }
  },
  dealersProvinces: {
    endpoint: DEFAULT_TAGCLOUD_ENDPOINT,
    params: {
      name: 'dealers_provinces',
      searchSectionId: SEARCH_SECTION_IDS.allOffers
    }
  },
  dealersMakes: {
    endpoint: DEFAULT_TAGCLOUD_ENDPOINT,
    params: {
      name: 'dealers_makes',
      searchSectionId: SEARCH_SECTION_IDS.allOffers
    }
  },
  dealersCities: {
    endpoint: DEFAULT_TAGCLOUD_ENDPOINT,
    params: {
      name: 'dealers_cities',
      searchSectionId: SEARCH_SECTION_IDS.allOffers
    }
  }
}

export const ADS_LIST_TAGCLOUD_PER_OFFER_TYPE = [
  // [0] SECOND_HAND
  TAGCLOUD_ENDPOINTS.default,
  // [1] NEW_VEHICLE
  {
    ...TAGCLOUD_ENDPOINTS.default,
    params: {
      searchSectionId: SEARCH_SECTION_IDS.newVehicles
    }
  },
  // [2] KM0
  {
    ...TAGCLOUD_ENDPOINTS.default,
    params: {
      searchSectionId: SEARCH_SECTION_IDS.km0
    }
  },
  {
    ...TAGCLOUD_ENDPOINTS.default,
    params: {
      searchSectionId: SEARCH_SECTION_IDS.km0
    }
  },
  {
    ...TAGCLOUD_ENDPOINTS.default,
    params: {
      searchSectionId: SEARCH_SECTION_IDS.km0
    }
  },
  {
    ...TAGCLOUD_ENDPOINTS.default,
    params: {
      searchSectionId: SEARCH_SECTION_IDS.km0
    }
  },
  {
    ...TAGCLOUD_ENDPOINTS.default,
    params: {
      searchSectionId: SEARCH_SECTION_IDS.km0
    }
  }
]

// Please take theme as reference to add values:
// https://github.mpi-internal.com/scmspain/frontend-mt--uilib-theme/blob/master/src/shared/_settings.scss#L111
export const breakpoints = {
  xxs: '0px',
  xs: '480px',
  s: '600px',
  m: '800px',
  l: '970px',
  xl: '1300px',
  xxl: '1440px'
}

export const LOGIN_STEPS = {
  GIGYA: 'gigya-screens',
  VERIFICATION_REMINDER: 'verification-reminder'
}

export const LOGIN_SCREENSET_ID_MAPPING = {
  completeRegistration: 'gigya-complete-registration-screen',
  login: 'login-mt',
  register: 'register-mt',
  forgot: 'forgot-password-mt',
  reset: 'reset-password-mt',
  default: 'register-mt'
}

export const GIGYA_CONFIG = {
  screenSet: 'MT-RegistrationLogin',
  containerID: 'gigya-login'
}

export const USER_CONTACT_BY_MAIL_RESPONSES = {
  202: {
    status: 'success',
    literal: 'USER_CONTACT_BY_MAIL_RESPONSE_SUCCESS'
  },
  200: {
    status: 'success',
    literal: 'USER_CONTACT_BY_MAIL_V2_RESPONSE_SUCCESS'
  },
  400: {
    status: 'error',
    literal: 'USER_CONTACT_BY_MAIL_RESPONSE_ERROR'
  },
  403: {
    status: 'error',
    literal: 'USER_CONTACT_BY_MAIL_RESPONSE_ERROR'
  },
  404: {
    status: 'error',
    literal: 'USER_CONTACT_BY_MAIL_RESPONSE_ERROR'
  },
  422: {
    status: 'error',
    literal: 'USER_CONTACT_BY_MAIL_RESPONSE_ERROR'
  },
  500: {
    status: 'error',
    literal: 'USER_CONTACT_BY_MAIL_RESPONSE_ERROR'
  }
}

export const DEFAULT_USER_CONTACT_BY_MAIL_RESPONSE = USER_CONTACT_BY_MAIL_RESPONSES['500']

export const USER_TAKEOUT_RESPONSES = {
  in_progress: {
    title: 'USER_TAKEOUT_TITLE_IN_PROGRESS',
    subtitle: 'USER_TAKEOUT_SUBTITLE_IN_PROGRESS'
  },
  completed: {
    title: 'USER_TAKEOUT_TITLE_COMPLETED',
    subtitle: 'USER_TAKEOUT_SUBTITLE_COMPLETED'
  },
  error: {
    title: 'USER_TAKEOUT_TITLE_ERROR',
    subtitle: 'USER_TAKEOUT_SUBTITLE_ERROR'
  },
  unavailable: {
    title: 'USER_TAKEOUT_TITLE_UNAVAILABLE',
    subtitle: 'USER_TAKEOUT_SUBTITLE_UNAVAILABLE'
  }
}

export const PAYMENT_AD_PRODUCT_ID = '27'

export const DEFAULT_STORE_ID = 'WEB'

export const ORDER = {ASC: 'ASC', DESC: 'DESC'}

/**
 * @exports ERRORS
 */
export const ERRORS = {
  UPDATE_PHONE_USER_ERROR: commonErrors.UpdatePhoneUserError,
  USER_NOT_LOGGED_IN_USER_ERROR: commonErrors.UserNotLoggedInUserError,
  GET_SEARCH_DATA_FROM_URL_ADS_ERROR: commonErrors.GetSearchDataFromUrlError,
  CONTACT_VALIDATION_SELLER_ERROR: commonErrors.ContactValidationSellerError,
  EMPTY_EMAIL_SELLER_ERROR: commonErrors.EmptyEmailSellerError,
  EMPTY_NAME_SELLER_ERROR: commonErrors.EmptyNameSellerError,
  GENERIC_SELLER_SELLER_ERROR: commonErrors.GenericSellerError,
  INVALID_EMAIL_SELLER_ERROR: commonErrors.InvalidEmailSellerError,
  INVALID_PHONE_SELLER_ERROR: commonErrors.InvalidPhoneSellerError,
  NOT_FOUND_CHAT_ASSISTANT_ERROR: commonErrors.NotFoundAssistantError
}

/**
 * @exports FILTER_NAMES
 */
export const FILTER_NAMES = {
  BODY_TYPE_CATEGORY: 'bodyTypeCategory',
  BODY_TYPE: 'bodyTypeIds',
  CATEGORY_1: 'categoryId',
  CATEGORY_2: 'category2Id',
  CITY: 'city',
  COLOR: 'colorIds',
  DOOR: 'doors',
  DRIVEN_WHEELS: 'drivenWheelsIds',
  ELECTRIC_AUTONOMY: 'electricAutonomy',
  ELECTRIC_BATTERY_CAPACITY: 'batteryCapacity',
  ELECTRIC_CHARGING_TIME_FAST_MODE: 'chargingTimeFastMode',
  ELECTRIC_CHARGING_TIME_STANDARD_MODE: 'chargingTimeStandardMode',
  ENVIRONMENTAL_LABEL: 'environmentalLabels',
  EQUIPMENTS: 'equipments',
  EXCLUDED_VEHICLES: 'excludedVehicles',
  FINANCING_ENTRY: 'entry',
  FINANCING_TERMS: 'maxTerms',
  FEE: 'fee',
  FUEL_TYPE: 'fuelTypeIds',
  HAS_INSTALMENT: 'hasInstalment',
  HAS_PHOTO: 'hasPhoto',
  HAS_ONLINE_FINANCING: 'hasOnlineFinancing',
  HAS_PRICE_DROP: 'hasPriceDrop',
  HAS_RESERVATION: 'hasReservation',
  HAS_STOCK: 'hasStock',
  HAS_WARRANTY: 'hasWarranty',
  HP: 'hp',
  IS_CERTIFIED: 'isCertified',
  IS_FINANCED: 'isFinanced',
  INSTALMENT: 'instalment',
  KMS: 'kms',
  LITRES: 'litres',
  LOCATION: 'location',
  LOCATION_RADIO: 'locationRadio',
  LOCATION_TEXT: 'locationText',
  LUGGAGE_CAPACITY: 'luggageCapacity',
  MAKE: 'makeId',
  MAKE_NAME: 'make',
  MODEL: 'model',
  MODEL_VERSION: 'modelVersionId',
  MONTHLY_SUBSCRIPTION_COMMITMENT: 'commitmentMonths',
  MONTHLY_SUBSCRIPTION_FEE: 'monthlySubscriptionFee',
  OFFER_TYPE: 'filteredOfferTypeId',
  ONLY_PENINSULA: 'onlyPeninsula',
  PAGE_NUMBER: 'pageNumber',
  PRICE: 'price',
  PRICE_RANK: 'priceRank',
  PROVINCE: 'provinceIds',
  RATING: 'rating',
  SEARCH_TEXT: 'searchText',
  SEAT: 'seats',
  SELLER_TYPE: 'sellerTypeId',
  SORT_BY: 'sortBy',
  SORT_ORDER: 'sortOrder',
  TARGET_BUYER: 'targetBuyer',
  TRANSMISSION_TYPE: 'transmissionTypeId',
  VEHICLES: 'vehicles',
  VEHICLE_STATE: 'subscriptionVehicleState',
  VERSION: 'version',
  YEAR: 'year'
}

export const AGGREGATIONS_FILTER_NAMES = {
  bodyType: FILTER_NAMES.BODY_TYPE,
  fuelType: FILTER_NAMES.FUEL_TYPE,
  luggageCapacity: FILTER_NAMES.LUGGAGE_CAPACITY,
  make: FILTER_NAMES.MAKE,
  model: FILTER_NAMES.MODEL,
  province: FILTER_NAMES.PROVINCE
}

export const TRACKING_FILTER_NAMES = {
  [FILTER_NAMES.BODY_TYPE]: 'body_types',
  [FILTER_NAMES.CATEGORY_2]: 'status_car',
  [FILTER_NAMES.CITY]: 'city',
  [FILTER_NAMES.COLOR]: 'colors',
  [FILTER_NAMES.DOOR]: {FROM: 'doors_min', TO: 'doors_max'},
  [FILTER_NAMES.DRIVEN_WHEELS]: 'driven_wheels',
  [FILTER_NAMES.ELECTRIC_AUTONOMY]: {FROM: 'autonomy_min', TO: 'autonomy_max'},
  [FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY]: {FROM: 'battery_cap_min', TO: 'battery_cap_max'},
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE]: {
    FROM: 'charge_time_min',
    TO: 'charge_time_max',
    TYPE: 'charge_time_type'
  },
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE]: {
    FROM: 'charge_time_min',
    TO: 'charge_time_max',
    TYPE: 'charge_time_type'
  },
  [FILTER_NAMES.ENVIRONMENTAL_LABEL]: 'environmental_labels',
  [FILTER_NAMES.EQUIPMENTS]: 'equipments',
  [FILTER_NAMES.FINANCED_PRICE]: {
    FROM: 'financed_price_min',
    TO: 'financed_price_max'
  },
  [FILTER_NAMES.FUEL_TYPE]: 'fuel_types',
  [FILTER_NAMES.HAS_ONLINE_FINANCING]: 'has_online_financing',
  [FILTER_NAMES.HAS_PHOTO]: 'has_photo',
  [FILTER_NAMES.HAS_RESERVATION]: 'has_reservation',
  [FILTER_NAMES.HAS_PRICE_DROP]: 'has_price_drop',
  [FILTER_NAMES.HAS_STOCK]: 'has_stock',
  [FILTER_NAMES.HAS_WARRANTY]: 'warranty',
  [FILTER_NAMES.HP]: {FROM: 'power_min', TO: 'power_max'},
  [FILTER_NAMES.INSTALMENT]: {
    FROM: 'instalment_min',
    TO: 'instalment_max'
  },
  [FILTER_NAMES.FINANCING_ENTRY]: 'entry',
  [FILTER_NAMES.FINANCING_TERMS]: 'terms',
  [FILTER_NAMES.IS_CERTIFIED]: 'certification',
  [FILTER_NAMES.IS_FINANCED]: 'financed_price',
  [FILTER_NAMES.KMS]: {FROM: 'km_min', TO: 'km_max'},
  [FILTER_NAMES.LITRES]: {FROM: 'cc_min', TO: 'cc_max'},
  [FILTER_NAMES.LOCATION_RADIO]: 'radio',
  [FILTER_NAMES.LOCATION_TEXT]: 'cp_municipio',
  [FILTER_NAMES.LUGGAGE_CAPACITY]: 'luggage_capacity_type',
  [FILTER_NAMES.EXCLUDED_VEHICLES]: {MAKE: 'exclude_brand', MODEL: 'exclude_model'},
  [FILTER_NAMES.MAKE]: 'brand',
  [FILTER_NAMES.MODEL_VERSION]: 'model',
  [FILTER_NAMES.MODEL]: 'model',
  [FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT]: 'monthly_subscription_commitments',
  [FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE]: {
    FROM: 'monthly_subscription_fee_min',
    TO: 'monthly_subscription_fee_max'
  },
  [FILTER_NAMES.OFFER_TYPE]: 'status_car',
  [FILTER_NAMES.ONLY_PENINSULA]: 'peninsula',
  [FILTER_NAMES.PRICE]: {FROM: 'price_min', TO: 'price_max'},
  [FILTER_NAMES.PRICE_RANK]: 'price_indicator_filter',
  [FILTER_NAMES.PROVINCE]: 'provinces',
  [FILTER_NAMES.RATING]: {FROM: 'rating_min', TO: 'rating_max'},
  [FILTER_NAMES.SEARCH_TEXT]: 'keywords',
  [FILTER_NAMES.SEAT]: {FROM: 'seats_min', TO: 'seats_max'},
  [FILTER_NAMES.SELLER_TYPE]: 'seller_type',
  [FILTER_NAMES.SORT_BY]: 'order',
  [FILTER_NAMES.TARGET_BUYER]: 'target_buyer',
  [FILTER_NAMES.TRANSMISSION_TYPE]: 'transmission',
  [FILTER_NAMES.VEHICLES]: 'vehicles',
  [FILTER_NAMES.VEHICLE_STATE]: 'vehicle_state',
  [FILTER_NAMES.VERSION]: 'version',
  [FILTER_NAMES.YEAR]: {FROM: 'year_min', TO: 'year_max'},
  offerType: 'offer_type'
}

/**
 * @exports SORT_FIELDS
 */
export const SORT_FIELDS = {
  CC: 'cc',
  FINANCED_PRICE: FILTER_NAMES.FINANCED_PRICE,
  FEE: 'fee',
  HP: FILTER_NAMES.HP,
  KM: 'km',
  MONTHLY_SUBSCRIPTION_FEE: FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE,
  PRICE: FILTER_NAMES.PRICE,
  RANDOM: 'random',
  RELEVANCE: 'relevance',
  TITLE: 'title',
  YEAR: FILTER_NAMES.YEAR,
  INSTALMENT: 'financingInstalment'
}

export const SORT_QUERY_PARAM = {
  [SORT_FIELDS.CC]: 'cc',
  [SORT_FIELDS.FINANCED_PRICE]: 'FinancedPrice',
  [SORT_FIELDS.HP]: 'hp',
  [SORT_FIELDS.KM]: 'Kilometers',
  [SORT_FIELDS.MONTHLY_SUBSCRIPTION_FEE]: 'Price',
  [SORT_FIELDS.PRICE]: 'Price',
  [SORT_FIELDS.RELEVANCE]: 'SortDate',
  [SORT_FIELDS.TITLE]: 'title',
  [SORT_FIELDS.YEAR]: 'Year'
}

export const QUERY_PARAM_TARGET_PAGE = 'targetPage'

export const ADD_FAVORITE_QUERY_PARAM = 'addFavorite'

export const EMPTY_STRING = ''

export const REGEX_PHONE = /\+?\d{9,15}/g

export const REGEX_ACCEPTED_COMMITMENT_MONTHS = /(12|24|36|48)/g

export const REGEX_IBAN_ES_FORMAT = /^([ES]{2})(\d{2})\s*\t*(\d{4})\s*\t*(\d{4})\s*\t*(\d{2})\s*\t*(\d{10})$/g

export const REGEX_VALID_PHONE_FORMAT = /^(\+34|0034|34)?[6|7|8|9][0-9]{8}$/

export const REGEX_MOBILE_PHONE = /^(6|7)[0-9]{8}$/

export const REGEX_PHONE_NUMBERS_AND_HACKY_PHONE_VARIATIONS =
  /(\\+34|0034|34|46)?([^0-9]|\n|\t){0,1}((6|8|7|9).?)([oO0-9].?){7}[oO0-9]/

export const REGEX_NOT_ALLOWED_CHARACTERS = /[`~@#$^¬|=<>{}[\]\\]+|null|^$]/

export const REGEX_EMAIL = /^([A-Za-z0-9_\-.+])+@([\u00F1A-Za-z0-9_\-.])+\.([\u00F1A-Za-z]{2,4})$/

export const REGEX_TAGS =
  /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>|<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>|<[^>]+(?:on\w+|javascript:)[^>]*>/gi

export const REGEX_SPAIN_POSTALCODE = /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/

export const REGEX_SPAIN_ID = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i

export const REGEX_CAR_PLATE =
  /(^\d{4}[B-DF-HJ-NPR-TV-Z]{3}$)|(^(VI|AB|A|AL|AV|BA|PM|IB|B|BU|CC|CA|CS|CR|CO|C|CU|GE|GI|GR|GU|SS|H|HU|J|LE|L|LO|LR|LU|M|MA|MU|NA|OR|OU|O|P|GC|PO|SA|TF|S|SG|SE|SO|T|TE|TO|V|VA|BI|ZA|Z|CE|ML)\d{4}[A-PS-Z]{1,2}$)/

export const REGEX_MOTO_PLATE =
  /(^\d{4}[B-DF-HJ-NPR-TV-Z]{3}$)|(^(VI|AB|A|AL|AV|BA|PM|IB|B|BU|CC|CA|CS|CR|CO|C|CU|GE|GI|GR|GU|SS|H|HU|J|LE|L|LO|LR|LU|M|MA|MU|NA|OR|OU|O|P|GC|PO|SA|TF|S|SG|SE|SO|T|TE|TO|V|VA|BI|ZA|Z|CE|ML)\d{4}[A-PS-Z]{1,2}$)|(^C\d{4}[B-DF-HJ-NPR-TV-Z]{3}$)|(^\d{1,4}[A-Z]{1,2}$)/

export const REGEX_URLS =
  /(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?/

export const REGEX_CODE =
  /<\s*\/?\s*script\b[^>]*>|<\s*\/?\s*style\b[^>]*>|<[^>]*?(?:on\w+|javascript:|data:|vbscript:)[^>]*>|\/\*[\s\S]*?\*\/|\/\/.*|<\/?[^>]+>|[a-zA-Z0-9_$]+\.[a-zA-Z0-9_$]+\(|\bfunction\s*\(|function\(\b|\bvar\b|\bconst\b|\blet\b|\bif\b|\belse\b|\bdocument\s*\.\s*|document\.\s*|\bwhile\b|\breturn\b|{|\}|==|!=|>|<|>=|<=|&&|\|\|/gi

/**
 * @exports REQUEST_HEADERS
 */
export const REQUEST_HEADERS = {
  ADOBE_MC_VISITOR_ID: 'X-Adevinta-AMCVID',
  CAPTCHA_ORIGIN: 'Captcha-Origin',
  CAPTCHA_TOKEN: 'Captcha-Token',
  CHANNEL: 'X-Adevinta-Channel',
  CONTACT_TOKEN: 'Contact-Token',
  EUCONSENT_V2: 'X-Adevinta-EUCONSENT-V2',
  SESSION_ID: 'X-Adevinta-Session-Id',
  TENANT: 'X-Schibsted-Tenant',
  TOKEN: 'token', // Header for secure requests to KrakenD (no API-WEB)
  USERID: 'userid', // Header for secure requests to KrakenD (no API-WEB)
  USER_ID: 'X-Adevinta-User-Id',
  URL: 'X-Adevinta-Page-Url',
  REFERER: 'X-Adevinta-Referer',
  BEARER: 'X-Adevinta-Bearer',
  IMPERVA: 'X-D-token'
}

/**
 * @exports DEFAULT_REQUEST_TIMEOUT
 */
export const DEFAULT_REQUEST_TIMEOUT = 10000

/**
 * @exports CALL_TRACKING_SERVICES
 */
export const CALL_TRACKING_SERVICES = {
  DIALOGA: 'Dialoga',
  FREESPEE: 'Freespee'
}

export const FORM_CONTACT_SELLER_ID = 'form-contact-seller-id'

export const NAVIGATION_TYPES = {
  ADS: 'ads'
}

export const NAVIGATION_DATA_KEYS = {
  [NAVIGATION_TYPES.ADS]: 'NavigationDataAdsKey'
}

export const CONTACT_TOKEN_KEY = 'ContactTokenKey'

export const SEM_GOOGLE_SESSION_KEY = 'SemGoogle'

export const SEM_GOOGLE_QUERY = 'stc=sem-google'

export const CARFAX_PROVIDER_URL =
  '&utm_medium=website&utm_source=%{sourceAppName}&utm_campaign=classifieds_integrations&utm_content=website_button&ct_st=%{sellerType}&ct_pm=model_1&ct_ts=consumer'

export const IOS_OS_NAME = 'ios'
export const ANDROID_OS_NAME = 'android'

export const CHROME_BROWSER_NAME = 'Chrome'

export const DEFAULT_BRAND_DAY_ENABLED_RESPONSE = false

export const CARFAX_SELLER_TYPES = {
  PRIVATE: 'private',
  PROFESSIONAL: 'dealer'
}

export const DEFAULT_IMAGE_PLACEHOLDER = 'images/no-photo.png'

export const DEALER_SERVICES_TYPES = {
  BAG_HEART: 'bag-heart',
  BREAKDOWNS_REPAIRS: 'breakdowns-repairs',
  CAR_EXTENDED_WARRANTY: 'car-extended-warranty',
  CASH: 'cash',
  CERTIFICATION: 'certification',
  CONFIGURABLE_CONDITIONS: 'configurable-conditions',
  DEAL: 'deal',
  DELIVERY: 'delivery',
  DRIVER_CARE: 'driver-care',
  EARLY_CANCELLATION_INSURANCE: 'early-cancellation-insurance',
  EARTH_HOME: 'earth-home',
  EXHIBITION: 'exhibition',
  FINANCING: 'financing',
  FINES_MANAGEMENT: 'fines-management',
  FLEXIBLE_CANCELLATION: 'flexible-cancellation',
  FULL_COMPREHENSIVE_INSURANCE: 'full-comprehensive-insurance',
  GARAGE: 'garage',
  HOME_DELIVERY: 'home-delivery',
  INSPECTION_REGISTRATION_TAXES: 'inspection-registration-taxes',
  INSURANCE_WITHOUT_EXCESS: 'insurance-without-excess',
  INSURANCE: 'insurance',
  MAINTENANCE: 'maintenance',
  MONTHLY_SUBSCRIPTION: 'monthly-subscription',
  MULTIPLE_DRIVERS: 'multiple-drivers',
  NO_COMMITMENT: 'no-commitment',
  NO_ENTRY_FEE: 'no-entry-fee',
  ONLINE_SHOPPING: 'online-shopping',
  ONLINE: 'online',
  PARKING: 'parking',
  PICKUP_DELIVERY: 'pickup-delivery',
  PICKUP: 'pickup',
  PROFESSIONAL_ADVICE: 'professional-advice',
  PURCHASE_OPTION: 'purchase-option',
  RENTING: 'renting',
  REPLACEMENT_VEHICLE: 'replacement-vehicle',
  REPLACEMENT: 'replacement',
  ROAD_ASSISTANCE: 'road-assistance',
  TRIAL_PERIOD: 'trial-period',
  TRIAL: 'trial',
  TYRES: 'tyres',
  UNLIMITED_MILEAGE: 'unlimited-mileage',
  VEHICLE_CHANGE: 'vehicle-change',
  VEHICLE_PRE_DELIVERY: 'vehicle-pre-delivery',
  WARRANTY_EXTENSION: 'warranty-extension'
}

export const DEALER_SERVICES_ORDER = [
  // order defined for subscription
  DEALER_SERVICES_TYPES.NO_ENTRY_FEE,
  DEALER_SERVICES_TYPES.ONLINE,
  DEALER_SERVICES_TYPES.CONFIGURABLE_CONDITIONS,
  DEALER_SERVICES_TYPES.MONTHLY_SUBSCRIPTION,
  DEALER_SERVICES_TYPES.NO_COMMITMENT,
  DEALER_SERVICES_TYPES.UNLIMITED_MILEAGE,
  DEALER_SERVICES_TYPES.VEHICLE_CHANGE,
  DEALER_SERVICES_TYPES.FLEXIBLE_CANCELLATION,
  DEALER_SERVICES_TYPES.HOME_DELIVERY,
  DEALER_SERVICES_TYPES.FULL_COMPREHENSIVE_INSURANCE,
  DEALER_SERVICES_TYPES.INSURANCE_WITHOUT_EXCESS,
  DEALER_SERVICES_TYPES.EARLY_CANCELLATION_INSURANCE,
  DEALER_SERVICES_TYPES.INSPECTION_REGISTRATION_TAXES,
  DEALER_SERVICES_TYPES.MAINTENANCE,
  DEALER_SERVICES_TYPES.BREAKDOWNS_REPAIRS,
  DEALER_SERVICES_TYPES.TYRES,
  DEALER_SERVICES_TYPES.PICKUP_DELIVERY,
  DEALER_SERVICES_TYPES.ROAD_ASSISTANCE,
  DEALER_SERVICES_TYPES.REPLACEMENT_VEHICLE,
  DEALER_SERVICES_TYPES.FINES_MANAGEMENT,
  DEALER_SERVICES_TYPES.DRIVER_CARE,
  DEALER_SERVICES_TYPES.PROFESSIONAL_ADVICE,
  DEALER_SERVICES_TYPES.MULTIPLE_DRIVERS,
  DEALER_SERVICES_TYPES.TRIAL_PERIOD,
  DEALER_SERVICES_TYPES.VEHICLE_PRE_DELIVERY,
  DEALER_SERVICES_TYPES.PURCHASE_OPTION,
  // end of order defined for subscription
  DEALER_SERVICES_TYPES.BAG_HEART,
  DEALER_SERVICES_TYPES.CAR_EXTENDED_WARRANTY,
  DEALER_SERVICES_TYPES.CASH,
  DEALER_SERVICES_TYPES.CERTIFICATION,
  DEALER_SERVICES_TYPES.DEAL,
  DEALER_SERVICES_TYPES.DELIVERY,
  DEALER_SERVICES_TYPES.EARTH_HOME,
  DEALER_SERVICES_TYPES.EXHIBITION,
  DEALER_SERVICES_TYPES.FINANCING,
  DEALER_SERVICES_TYPES.GARAGE,
  DEALER_SERVICES_TYPES.INSURANCE,
  DEALER_SERVICES_TYPES.ONLINE_SHOPPING,
  DEALER_SERVICES_TYPES.PARKING,
  DEALER_SERVICES_TYPES.PICKUP,
  DEALER_SERVICES_TYPES.RENTING,
  DEALER_SERVICES_TYPES.REPLACEMENT,
  DEALER_SERVICES_TYPES.TRIAL,
  DEALER_SERVICES_TYPES.WARRANTY_EXTENSION
]
